import React from 'react';
import FadeInFromLeft from './FadeInFromLeft';
import './Welcome.css';

const steps = [
  {
    number: "1",
    title: "Get Matched Instantly",
    description: "Fill out your profile and instantly get paired with best-fit faculty or students using our AI-powered matching."
  },
  {
    number: "2",
    title: "Connect & Collaborate", 
    description: "Instantly message your matches, set up meetings, and share documents securely."
  },
  {
    number: "3",
    title: "Rest Easy",
    description: "Return for any and all graduate resources—housing, finance, guidance, and more. We're always here when you need us."
  }
];

export default function HowItWorks({ isMobile }) {
  return (
    <section className="how-it-works">
      <FadeInFromLeft>
        <h2 className={`section-title-how-neuhawk-works ${isMobile ? 'mobile' : ''}`}>
          How NeuHawk Works
        </h2>
      </FadeInFromLeft>
      <div className={`steps-container ${isMobile ? 'mobile' : ''}`}>
        {steps.map((step, index) => (
          <FadeInFromLeft key={step.number} delay={index * 140}>
            <div className={`step-card ${isMobile ? 'mobile' : ''}`}>
              <div className="step-number">
                {step.number}
              </div>
              <h3 className={`step-title ${isMobile ? 'mobile' : ''}`}>
                {step.title}
              </h3>
              <p className={`step-description ${isMobile ? 'mobile' : ''}`}>
                {step.description}
              </p>
            </div>
          </FadeInFromLeft>
        ))}
      </div>
    </section>
  );
}